module.exports = __webpack_public_path__ + "img/230-3a7200.png";